export const isHttpUrl = (url: Nullable<string> | undefined): url is string => {
  if (!url) {
    return false;
  }

  const protocol = URL.parse(url, window.location.href)?.protocol;

  return (
    protocol === 'https:' ||
    (protocol === 'http:' && window.location.protocol === 'http:')
  );
};
